import { FETCH_INSIGHTS } from '../../dataFetchers/insightsDataFetcher';
import { createDummyDataHomeInsights } from '../../helpers/noDataHelper';

const insightsReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_INSIGHTS.FETCH_INSIGHTS:
      state = {
        ...state,
        insightList: action.payload.response.length > 0 ? action.payload.response : createDummyDataHomeInsights(action.payload.translations),
        insightListError: action.payload.response.length > 0 ? null : true
      };
      break;
    case FETCH_INSIGHTS.FETCH_INSIGHTS_FAILED:
      state = {
        ...state,
        insightList: createDummyDataHomeInsights(action.payload.translations),
        insightListError: true
      }
      break;
    default: 
      break;
  }
  return state;
}

export default insightsReducer;
